module.exports = __webpack_public_path__ + "img/air.6d0605bf.jpg";